import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

const posts = [
  {
    category: 'Product Update',
    title: 'How ApplyAI Helped 1,000 Students Land Interviews',
    preview:
      'We recently crossed a major milestone: over 1,000 students have landed interviews through our automated application platform. Here is what we learned along the way...',
    date: 'March 15, 2026',
    slug: '/blog/applyai-1000-students',
  },
  {
    category: 'Career Tips',
    title: '5 Cold Email Templates That Actually Get Responses',
    preview:
      'Cold emailing recruiters can feel daunting, but it remains one of the most effective ways to get noticed. We analyzed thousands of outreach emails to find what works...',
    date: 'February 28, 2026',
    slug: '/blog/cold-email-templates',
  },
  {
    category: 'Engineering',
    title: 'Building AI That Writes Cover Letters: Our Approach',
    preview:
      'Cover letters are tedious yet important. We built an AI system that generates personalized, role-specific cover letters at scale. Here is how we approached the problem...',
    date: 'February 10, 2026',
    slug: '/blog/ai-cover-letters',
  },
];

const Blog = () => {
  return (
    <div className="blog-page">
      <div className="blog-container">
        <h1 className="blog-title">Blog</h1>
        <p className="blog-subtitle">
          Tips, guides, and product updates from the ApplyAI team.
        </p>

        <div className="blog-list">
          {posts.map((post, i) => (
            <article className="blog-card" key={i}>
              <span className="blog-category">{post.category}</span>
              <h2 className="blog-card-title">{post.title}</h2>
              <p className="blog-card-preview">{post.preview}</p>
              <p className="blog-card-date">{post.date}</p>
              <Link className="blog-read-more" to={post.slug}>
                Read more &rarr;
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
